// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicationPermissionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface PermissionCheckParams {
  listingAlias: ListingAlias;
}

export const CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_Path =
  '/api/web/landlord/v1/applications/permissionCheck';

export const CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck = (
  getParams: PermissionCheckParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PermissionCheckParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicationPermissionsWebApiHandler_permissionCheck_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
